import { useQuery } from '@tanstack/vue-query';
import { computed } from '@vue/composition-api';
import { DashboardService } from '../../../api/service/dashboard.service';
import { widgetKeys } from '../../../api/widget-keys';

export const useTopPerformers = (interval: { from: number; to: number }) =>
  useQuery({
    queryKey: computed(() => widgetKeys.topPerformersDetail(interval)),
    queryFn: () => DashboardService.loadTopPerformers(interval),
  });
